import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';

import { GISMapField as EditComponent } from '../tsx/GISMapField';
//declare var require: any;

export class GISMapField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            noTitle: true
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal: any = {}, options?, directionOptions?) {
        super(glob, title, GISMapField.defaultValidators, validators, defaultVal, options, directionOptions);
    }
}
